module.exports = __webpack_public_path__ + "static/media/usa_2.3eb107b4.jpg";